import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em] text-brand">
    {children}
  </p>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2
    className={`font-display text-2xl font-black uppercase leading-[0.95] tracking-tight text-ink sm:text-3xl lg:text-4xl ${className}`}
  >
    {children}
  </h2>
);

export default Reveal;
